import React, { useState } from "react";
import "./index.css";
import { siteContent } from "../content";

const detalles = siteContent.details.items;

const Accordion = ({ detalles, onChange }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleClick = (index, image) => {
        setActiveIndex(index);
        onChange(image);
    };

    return (
        <div className="accordionWrapper">
            {detalles.map((detalle, index) => (
                <div key={detalle.id} onClick={() => handleClick(index, detalle.image)} className={`accordionItem ${activeIndex === index ? 'active' : ''}`}>
                    <h3>{detalle.title} <span className={`arrow ${activeIndex === index ? 'open' : ''}`}>&#9662;</span></h3>
                    <p>{detalle.content}</p>
                </div>
            ))}
        </div>
    );
};

const DetallesProyecto = () => {
    const [selectedImage, setSelectedImage] = useState(detalles[0].image);

    const handleImageChange = (image) => {
        setSelectedImage(image);
    };

    return (
        <div className="section detallesProyecto">
            <div className="container-lg flex flexCol">
                <h5>{siteContent.details.eyebrow}</h5>
                <h2 className="titleSec">
                    {siteContent.details.title}
                </h2>
                <p className="pSec">{siteContent.details.description}</p>
                <div className="flex flexRow accordionDynamic">
                    <div className="visuals">
                        <img src={selectedImage} alt="Detalle visual" className="detalleImagen" />
                    </div>
                    <Accordion detalles={detalles} onChange={handleImageChange} />
                </div>
            </div>
        </div>
    );
};

export default DetallesProyecto;
